import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IEquipement} from '../../_models/Equipment';
import {BaseHubService} from './base-hub.service';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {IBaseObject} from '../../_models/BaseObject';
import {Store} from '@ngrx/store';
import {MainStoreState} from '../../_store/mainStoreState';
import {setEquipmentsSuccessAction} from '../../_store/EquipementStore/equipement.store';

@Injectable({
  providedIn: 'root',
})
export class EquipmentService extends BaseHubService<IEquipement> {
  constructor(
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService,
    private store: Store<MainStoreState>
  ) {
    super(
      'equipements',
      'hubs/equipementsHub',
      'Equipements',
      http,
      messageService,
      configService
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setEquipmentsSuccessAction({payload: data as IEquipement[]})
    );
  }
}
